
import axios from "axios";
const APIURL = process.env.REACT_APP_BASE_URL;
const apiList = [
    {
        name: "Birth Chart",
        method: "POST",
        endpoint: "/astrology/kundali",
        description: "Generate your kundali",
        request: {
            "year": 1985,
            "month": 7,
            "day": 17,
            "hour": 22,
            "minute": 30,
        }
    }
]
export default function Documentation() {
    const calAPI = async (endpoint, request) => {
        const res =  await axios.post(`https://maduraiastrology.com${endpoint}`, request);
        
        /*fetch(`http://localhost:3001${endpoint}`, {
             method: "POST",
             headers: {
                 "Content-Type": "application/json"
             },
             body: JSON.stringify(request,null,2),
         });*/
         console.log(res.data);
    }
    return (
        <div style={styles.container}>
            <h1>Astrology API Documentation</h1>
            <p>Welcome to the Astrology API Platform. Our APIs allow you to integrate
                horoscope matching, porutham calculations,and astrology services into your
                application usring secure, subscription-based access</p>
            <h2>Base URL</h2>
            <pre>https://maduraiastrology.com/</pre>
            <h2>Available APIs</h2>

            {apiList.map((api, index) => (
                <div style={styles.card}>
                    <h3>{api.name}</h3>
                    <p>{api.description}</p>
                    <p><b>Method:</b>{api.method}</p>
                    <p><b>Endpoint</b>{api.endpoint}</p>
                    <b>Sample Request : </b>
                    <pre style={styles.code}>
                        {JSON.stringify(api.request, null, 2)}
                    </pre>
                    <h2>Try Live API</h2>
                    <button onClick={() => calAPI(api.endpoint, api.request)}></button>
                </div>

            ))}

        </div>
    )
}


const styles = {
    container: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "40px",
        width: "100%"
    },
    title: {
        fontSize: "32px",
        color: "#7c2d12"
    },
    subtitle: {
        color: "#92400e",
        marginBottom: "20px"
    },
    card: {
        border: "1px solid #ddd",
        padding: 16,
        borderRadius: 8,
        marginBottom: 20,
    },
    code: {
        background: "#f4f4f4",
        padding: 10,
        borderRadius: 5,
    },
    input: {
        padding: "10px",
        fontSize: "14px",
        borderRadius: "6px",
        border: "1px solid #d1d5db"
    },
    button: {
        marginTop: "10px",
        padding: "12px",
        background: "#b45309",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        cursor: "pointer"
    }
};